export default "__VITE_ASSET__0aba07ca__"